export default __webpack_public_path__ + "static/media/loginBackE.ead88989.png";